module.exports = __webpack_public_path__ + "img/icon-ig.fa90e1e7.png";